/* Rising Sun FPV - "Supply Terminal" interactions (draft redesign).
   Vanilla JS, no dependencies. Honours prefers-reduced-motion. */
(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function each(sel, root, fn) {
    Array.prototype.forEach.call((root || d).querySelectorAll(sel), fn);
  }
  function onVisible(el, cb, margin) {
    if (!('IntersectionObserver' in window)) { cb(true); return null; }
    var io = new IntersectionObserver(function (entries) { cb(entries[0].isIntersecting, io); }, { rootMargin: margin || '0px' });
    io.observe(el);
    return io;
  }

  /* 1. Reveal sections as they scroll into view */
  function initReveal(root) {
    var els = (root || d).querySelectorAll('.rs-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }

  /* 2. Rotating hero words */
  function initRotator(root) {
    each('[data-rs-rotator]', root, function (r) {
      if (r.dataset.rsInit) return;
      r.dataset.rsInit = '1';
      var words = r.querySelectorAll('.rs-rotator__word');
      if (words.length < 2 || reduce) return;
      var i = 0;
      setInterval(function () {
        words[i].classList.remove('is-active');
        words[i].classList.add('is-leaving');
        var prev = words[i];
        setTimeout(function () { prev.classList.remove('is-leaving'); }, 600);
        i = (i + 1) % words.length;
        words[i].classList.add('is-active');
      }, 2600);
    });
  }

  /* 3. Count-up numbers in the HUD strip */
  function animateCount(el) {
    /* Only count plain quantities like "668" or "5,400+" (not times like "3pm") */
    var orig = el.textContent;
    var m = orig.match(/^(\D*)([\d,]+)([+%kK]?)$/);
    if (!m) return;
    var target = parseInt(m[2].replace(/,/g, ''), 10);
    if (!target || reduce) return;
    setTimeout(function () { el.textContent = orig; }, 1700);
    var useComma = m[2].indexOf(',') !== -1;
    var start = null, dur = 1400;
    function fmt(n) { return useComma ? n.toLocaleString('en-AU') : String(n); }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = m[1] + fmt(Math.round(target * eased)) + m[3];
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCounters(root) {
    var els = (root || d).querySelectorAll('[data-rs-count]');
    if (!els.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { animateCount(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.6 });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }

  /* 4. Terminal lines type themselves out */
  function initTerminal(root) {
    each('[data-rs-terminal]', root, function (term) {
      if (term.dataset.rsInit) return;
      term.dataset.rsInit = '1';
      var lines = term.querySelectorAll('.rs-terminal__line');
      if (!lines.length) return;
      var cursor = d.createElement('span');
      cursor.className = 'rs-terminal__cursor';
      cursor.setAttribute('aria-hidden', 'true');
      if (reduce) { lines[lines.length - 1].appendChild(cursor); return; }
      var texts = Array.prototype.map.call(lines, function (l) { var t = l.textContent; l.textContent = ''; return t; });
      var li = 0, ci = 0;
      function tick() {
        if (li >= lines.length) return;
        var line = lines[li];
        ci++;
        line.textContent = texts[li].slice(0, ci);
        line.appendChild(cursor);
        if (ci >= texts[li].length) { li++; ci = 0; setTimeout(tick, 320); } else { setTimeout(tick, 18 + Math.random() * 30); }
      }
      setTimeout(tick, 350);
    });
  }

  /* 5. 3D tilt + spotlight on hobby tiles */
  function initTilt(root) {
    if (reduce || !canHover) return;
    each('[data-rs-tilt]', root, function (el) {
      if (el.dataset.rsInit) return;
      el.dataset.rsInit = '1';
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--rx', (-y * 6).toFixed(2) + 'deg');
        el.style.setProperty('--ry', (x * 8).toFixed(2) + 'deg');
        el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* 6. Mission Planner: hobby tabs -> options */
  function initMission(root) {
    each('[data-rs-mission]', root, function (panel) {
      if (panel.dataset.rsInit) return;
      panel.dataset.rsInit = '1';
      var tabs = panel.querySelectorAll('[data-rs-tab]');
      function select(tab, focus) {
        Array.prototype.forEach.call(tabs, function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          var p = d.getElementById(t.getAttribute('aria-controls'));
          if (!p) return;
          p.hidden = !on;
          if (on) { p.classList.remove('is-anim'); void p.offsetWidth; p.classList.add('is-anim'); }
        });
        if (focus) tab.focus();
      }
      Array.prototype.forEach.call(tabs, function (tab, idx) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(idx + 1) % tabs.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(idx - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
    });
  }

  /* 7. Product rails: prev / next buttons */
  function initRails(root) {
    each('.rs-rail', root, function (sec) {
      if (sec.dataset.rsInit) return;
      sec.dataset.rsInit = '1';
      var track = sec.querySelector('[data-rs-rail]');
      if (!track) return;
      function step() { return Math.max(track.clientWidth * 0.8, 240); }
      var prev = sec.querySelector('[data-rs-prev]');
      var next = sec.querySelector('[data-rs-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    });
  }

  /* 8. Quick add to cart from rail cards (falls back to a normal form post) */
  function initQuickAdd() {
    d.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.classList || !f.classList.contains('rs-card__form') || !window.fetch) return;
      e.preventDefault();
      var btn = f.querySelector('button');
      btn.disabled = true;
      btn.classList.add('is-loading');
      var addUrl = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js';
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = '✓';
          d.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true } }));
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = '+';
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () { f.submit(); });
    });
  }

  /* 9. Motion tracker: sweep, range rings, drifting contacts, hobby blips that ping as the sweep passes */
  function initTracker(root) {
    each('[data-rs-tracker]', root, function (box) {
      if (box.dataset.rsInit) return;
      box.dataset.rsInit = '1';
      var screen = box.querySelector('.rs-tracker__screen');
      var c = box.querySelector('canvas');
      var readout = box.querySelector('[data-rs-tracker-readout]');
      var blips = Array.prototype.map.call(box.querySelectorAll('.rs-blip'), function (el) {
        var b = parseFloat(el.getAttribute('data-bearing')) || 0;
        var r = (parseFloat(el.getAttribute('data-range')) || 60) / 100;
        var rad = b * Math.PI / 180;
        var x = 50 + Math.sin(rad) * r * 50;
        var y = 50 - Math.cos(rad) * r * 50;
        el.style.left = x.toFixed(2) + '%';
        el.style.top = y.toFixed(2) + '%';
        if (x > 58) el.classList.add('rs-blip--left');
        return { el: el, bearing: b, last: -1 };
      });
      if (!c || !c.getContext) return;
      var ctx = c.getContext('2d');
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var s = 0, angle = 0, run = false, raf = 0, last = 0, contacts = [], pointer = null;
      var green = '109,255,159';
      function size() {
        var rect = screen.getBoundingClientRect();
        s = rect.width;
        c.width = Math.round(s * dpr); c.height = Math.round(s * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function spawn() {
        var a = Math.random() * Math.PI * 2;
        contacts.push({ a: a, r: 0.95, v: 0.0006 + Math.random() * 0.0012, life: 1 });
      }
      function draw(dt) {
        var R = s / 2, i;
        ctx.clearRect(0, 0, s, s);
        ctx.save();
        ctx.translate(R, R);
        /* rings + crosshair + ticks */
        ctx.strokeStyle = 'rgba(' + green + ',0.22)';
        ctx.lineWidth = 1;
        for (i = 1; i <= 4; i++) { ctx.beginPath(); ctx.arc(0, 0, R * i / 4 - 1, 0, Math.PI * 2); ctx.stroke(); }
        ctx.beginPath(); ctx.moveTo(-R, 0); ctx.lineTo(R, 0); ctx.moveTo(0, -R); ctx.lineTo(0, R); ctx.stroke();
        for (i = 0; i < 72; i++) {
          var ta = i * Math.PI / 36, len = i % 6 === 0 ? 10 : 4;
          ctx.beginPath();
          ctx.moveTo(Math.sin(ta) * (R - 2), -Math.cos(ta) * (R - 2));
          ctx.lineTo(Math.sin(ta) * (R - 2 - len), -Math.cos(ta) * (R - 2 - len));
          ctx.stroke();
        }
        /* sweep wedge */
        var sweep = angle * Math.PI / 180;
        for (i = 0; i < 28; i++) {
          var aa = sweep - i * 0.035;
          ctx.fillStyle = 'rgba(' + green + ',' + (0.2 * (1 - i / 28)).toFixed(3) + ')';
          ctx.beginPath(); ctx.moveTo(0, 0);
          ctx.arc(0, 0, R - 2, aa - Math.PI / 2 - 0.036, aa - Math.PI / 2);
          ctx.closePath(); ctx.fill();
        }
        ctx.strokeStyle = 'rgba(' + green + ',0.85)';
        ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(Math.sin(sweep) * (R - 2), -Math.cos(sweep) * (R - 2)); ctx.stroke();
        /* drifting contacts (move toward the centre) */
        for (i = contacts.length - 1; i >= 0; i--) {
          var k = contacts[i];
          if (run) { k.r -= k.v * dt; }
          if (k.r < 0.08) { contacts.splice(i, 1); continue; }
          var diff = ((sweep - k.a) % (Math.PI * 2) + Math.PI * 2) % (Math.PI * 2);
          var glow = Math.max(0, 1 - diff / 2.2);
          ctx.fillStyle = 'rgba(' + green + ',' + (0.15 + glow * 0.85).toFixed(2) + ')';
          ctx.beginPath(); ctx.arc(Math.sin(k.a) * k.r * R, -Math.cos(k.a) * k.r * R, 3 + glow * 2, 0, Math.PI * 2); ctx.fill();
        }
        /* pointer crosshair */
        if (pointer) {
          ctx.strokeStyle = 'rgba(255,176,0,0.8)';
          ctx.lineWidth = 1;
          ctx.beginPath(); ctx.arc(pointer.x - R, pointer.y - R, 10, 0, Math.PI * 2); ctx.stroke();
          ctx.beginPath();
          ctx.moveTo(pointer.x - R - 16, pointer.y - R); ctx.lineTo(pointer.x - R + 16, pointer.y - R);
          ctx.moveTo(pointer.x - R, pointer.y - R - 16); ctx.lineTo(pointer.x - R, pointer.y - R + 16);
          ctx.stroke();
        }
        ctx.restore();
        /* ping the hobby blips as the sweep passes them */
        blips.forEach(function (b) {
          var delta = ((angle - b.bearing) % 360 + 360) % 360;
          if (delta < 8 && b.last !== Math.floor(angle / 360)) {
            b.last = Math.floor(angle / 360);
            b.el.classList.add('is-ping');
            setTimeout(function () { b.el.classList.remove('is-ping'); }, 1300);
          }
        });
      }
      function loop(ts) {
        var dt = last ? Math.min(ts - last, 64) : 16;
        last = ts;
        angle += dt * 0.09;
        if (Math.random() < 0.012 && contacts.length < 6) spawn();
        draw(dt);
        if (run) raf = requestAnimationFrame(loop);
      }
      size();
      angle = 30;
      spawn(); spawn();
      draw(16);
      window.addEventListener('resize', function () { size(); draw(0); });
      if (canHover) {
        screen.addEventListener('pointermove', function (e) {
          var rect = screen.getBoundingClientRect();
          pointer = { x: e.clientX - rect.left, y: e.clientY - rect.top };
          if (readout) {
            var dx = pointer.x - rect.width / 2, dy = pointer.y - rect.height / 2;
            var brg = (Math.atan2(dx, -dy) * 180 / Math.PI + 360) % 360;
            var rng = Math.min(Math.sqrt(dx * dx + dy * dy) / (rect.width / 2), 1) * 50;
            readout.textContent = 'BRG ' + ('00' + Math.round(brg)).slice(-3) + '° / RNG ' + rng.toFixed(1) + 'M';
          }
          if (!run) draw(0);
        });
        screen.addEventListener('pointerleave', function () {
          pointer = null;
          if (readout) readout.textContent = blips.length + ' contacts';
          if (!run) draw(0);
        });
      }
      if (reduce) return;
      onVisible(box, function (vis) {
        if (vis && !run) { run = true; last = 0; raf = requestAnimationFrame(loop); }
        if (!vis) { run = false; cancelAnimationFrame(raf); }
      });
    });
  }

  /* 10. Facebook page events feed, built lazily at the right width (Page Plugin allows 180-500px) */
  function initFacebook(root) {
    each('[data-rs-fb]', root, function (box) {
      if (box.dataset.rsInit) return;
      box.dataset.rsInit = '1';
      function load() {
        var w = Math.max(180, Math.min(500, Math.floor(box.clientWidth - 24)));
        var h = parseInt(box.getAttribute('data-height'), 10) || 640;
        var params = 'href=' + encodeURIComponent(box.getAttribute('data-page')) +
          '&tabs=' + encodeURIComponent(box.getAttribute('data-tabs') || 'events') + '&width=' + w + '&height=' + h +
          '&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false';
        var f = d.createElement('iframe');
        f.src = 'https://www.facebook.com/plugins/page.php?' + params;
        f.width = w;
        f.height = h;
        f.title = 'Rising Sun FPV events on Facebook';
        f.loading = 'lazy';
        f.setAttribute('scrolling', 'no');
        f.setAttribute('allow', 'encrypted-media');
        var fallback = box.querySelector('.rs-fb__fallback');
        box.appendChild(f);
        f.addEventListener('load', function () { if (fallback) fallback.remove(); });
      }
      var io = onVisible(box, function (vis, obs) {
        if (vis) { if (obs) obs.disconnect(); load(); }
      }, '400px');
      if (!io && !box.querySelector('iframe')) { /* no IntersectionObserver: loaded immediately */ }
    });
  }

  /* 11. Load the Spline 3D viewer only when it scrolls into view */
  function initSpline(root) {
    each('[data-rs-lazy-spline]', root, function (box) {
      if (box.dataset.rsInit) return;
      box.dataset.rsInit = '1';
      function load() {
        var s = d.createElement('script');
        s.type = 'module';
        s.src = box.getAttribute('data-src');
        d.head.appendChild(s);
        var v = d.createElement('spline-viewer');
        v.setAttribute('url', box.getAttribute('data-url'));
        v.setAttribute('loading-anim-type', 'spinner-big-dark');
        v.setAttribute('hint', '');
        box.innerHTML = '';
        box.appendChild(v);
      }
      onVisible(box, function (vis, obs) {
        if (vis) { if (obs) obs.disconnect(); load(); }
      }, '300px');
    });
  }

  /* 12. In-page links to redesign sections (#events, /#events): offset for the sticky header */
  function initAnchors() {
    d.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      var hashAt = href.indexOf('#');
      var path = href.slice(0, hashAt);
      if (path && path !== window.location.pathname) return;
      var id = href.slice(hashAt + 1);
      var t = id && d.getElementById(id);
      if (!t || !t.classList.contains('rs-section')) return;
      e.preventDefault();
      e.stopPropagation();
      var h = 0;
      each('.shopify-section-group-header-group', d, function (s) {
        if (/sticky|fixed/.test(getComputedStyle(s).position)) h = Math.max(h, s.getBoundingClientRect().height);
      });
      var top = t.getBoundingClientRect().top + window.pageYOffset - h + 40;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    }, true);
  }


  /* 13. Airlock intro: the inline script in the hero shows it (so it can't flash late); this types the lines and opens the doors */
  function initBoot(root) {
    each('[data-rs-boot]', root, function (box) {
      if (box.dataset.rsInit || box.hidden) return;
      box.dataset.rsInit = '1';
      var lines = box.querySelectorAll('.rs-boot__line');
      var done = false;
      function open() {
        if (done) return;
        done = true;
        box.classList.add('is-open');
        setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); d.documentElement.classList.remove('rs-booting'); }, 1000);
      }
      Array.prototype.forEach.call(lines, function (l, i) { setTimeout(function () { l.classList.add('is-on'); }, 120 + i * 260); });
      setTimeout(open, 120 + lines.length * 260 + 380);
      box.addEventListener('click', open);
      d.addEventListener('keydown', function onKey(e) { if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') { open(); d.removeEventListener('keydown', onKey); } });
    });
  }

  /* 14. Live store status + same-day dispatch countdown (Brisbane time, no daylight saving).
         Closed dates (public holidays) come from the hero's data-closed list: one per line, "YYYY-MM-DD Name",
         or "YYYY-MM-DD HH:MM Name" to close early from that time. */
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DEFAULT_HOURS = { 0: ['09:00', '16:00'], 1: ['09:00', '18:00'], 2: ['09:00', '18:00'], 3: ['09:00', '18:00'], 4: ['09:00', '21:00'], 5: ['09:00', '18:00'], 6: ['09:00', '16:00'] };
  function brisbaneNow() { var n = new Date(); return new Date(n.getTime() + (n.getTimezoneOffset() + 600) * 60000); }
  function parseHM(v) { var m = /^(\d{1,2}):(\d{2})$/.exec(String(v || '').trim()); return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null; }
  function fmt12(min) { var h = Math.floor(min / 60), m = min % 60, ap = h >= 12 ? 'pm' : 'am'; return (h % 12 || 12) + (m ? ':' + ('0' + m).slice(-2) : '') + ap; }
  function dkey(dt) { return dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2); }
  function addDays(dt, i) { return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + i, 12); }
  function dayWord(i, dt) { return i === 1 ? 'tomorrow' : i < 7 ? DAYS[dt.getDay()] : DAYS[dt.getDay()] + ' ' + dt.getDate() + ' ' + MONTHS[dt.getMonth()]; }
  /* Opening minutes [open, close] for a date, or null if closed all day; a part-day closure brings closing time forward */
  function dayHours(hours, closed, dt) {
    var h = hours[dt.getDay()] || hours[String(dt.getDay())], c = closed[dkey(dt)];
    if (!h) return null;
    var o = parseHM(h[0]), e = parseHM(h[1]);
    if (o == null || e == null) return null;
    if (c) { if (c.from <= o) return null; if (c.from < e) e = c.from; }
    return [o, e];
  }
  function storeStatus(hours, now, closed) {
    var min = now.getHours() * 60 + now.getMinutes(), today = dayHours(hours, closed, now), c = closed[dkey(now)];
    if (today && min >= today[0] && min < today[1]) return { open: true, text: 'Open now, until ' + fmt12(today[1]) + (c && c.name ? ' (' + c.name + ')' : '') };
    if (today && min < today[0]) return { open: false, text: 'Closed, opens ' + fmt12(today[0]) + ' today' };
    var lead = c && c.name ? 'Closed for ' + c.name : 'Closed';
    for (var i = 1; i <= 60; i++) {
      var dt = addDays(now, i), dh = dayHours(hours, closed, dt);
      if (dh) return { open: false, text: lead + ', opens ' + fmt12(dh[0]) + ' ' + dayWord(i, dt) };
    }
    return { open: false, text: lead };
  }
  /* Dispatch runs Mon-Fri up to the cut-off; closed dates cancel it (a part-day closure before the cut-off brings the cut-off forward) */
  function dispatchCut(cutMin, closed, dt) {
    var wd = dt.getDay(), c = closed[dkey(dt)];
    if (wd === 0 || wd === 6) return 0;
    return c ? Math.min(cutMin, c.from) : cutMin;
  }
  function dispatchStatus(cutMin, now, closed) {
    var secs = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds(), cut = dispatchCut(cutMin, closed, now) * 60;
    if (secs < cut) {
      var left = cut - secs, h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60), sec = left % 60;
      return { live: true, text: 'Order within ' + (h ? h + 'h ' : '') + ('0' + m).slice(-2) + 'm ' + ('0' + sec).slice(-2) + 's' };
    }
    for (var i = 1; i <= 60; i++) {
      var dt = addDays(now, i);
      if (dispatchCut(cutMin, closed, dt) > 0) return { live: false, text: 'Next dispatch ' + dayWord(i, dt) };
    }
    return { live: false, text: 'Dispatch paused' };
  }
  function readHours(el) {
    try { var h = JSON.parse(el.getAttribute('data-hours') || ''); if (h && typeof h === 'object') return h; } catch (e) { /* fall back */ }
    return DEFAULT_HOURS;
  }
  function readClosed(el) {
    var out = {}, lines = String(el.getAttribute('data-closed') || '').split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var m = /^\s*(\d{4}-\d{2}-\d{2})(?:\s+(\d{1,2}:\d{2}))?\s*(.*)$/.exec(lines[i]);
      if (m) out[m[1]] = { from: (m[2] && parseHM(m[2])) || 0, name: m[3].replace(/^[\s\-–—:,]+/, '').trim() };
    }
    return out;
  }
  function initLive(root) {
    var boxes = (root || d).querySelectorAll('[data-rs-live]');
    var ticks = (root || d).querySelectorAll('[data-rs-ticker-live]');
    if (!boxes.length && !ticks.length) return;
    var src = d.querySelector('[data-rs-live]');
    var hours = src ? readHours(src) : DEFAULT_HOURS;
    var closed = src ? readClosed(src) : {};
    var cut = src ? (parseHM(src.getAttribute('data-cutoff')) || 900) : 900;
    function update(force) {
      if (!force && d.visibilityState === 'hidden') return;
      var now = brisbaneNow(), st = storeStatus(hours, now, closed), ds = dispatchStatus(cut, now, closed);
      Array.prototype.forEach.call(boxes, function (b) {
        var s = b.querySelector('[data-rs-live-store]'), p = b.querySelector('[data-rs-live-dispatch]');
        if (s) { s.textContent = st.text; s.className = 'rs-live__v ' + (st.open ? 'is-open' : 'is-closed'); }
        if (p) { p.textContent = ds.text; p.className = 'rs-live__v ' + (ds.live ? 'is-live' : 'is-next'); }
      });
      Array.prototype.forEach.call(d.querySelectorAll('[data-rs-ticker-live]'), function (t) {
        t.textContent = 'Townsville depot: ' + st.text + (ds.live ? ' // Same-day dispatch: ' + ds.text.replace(/^./, function (c) { return c.toLowerCase(); }) : '');
        t.classList.toggle('is-open', st.open);
      });
    }
    update(true);
    if (!initLive.timer) {
      initLive.timer = setInterval(update, 1000);
      d.addEventListener('visibilitychange', function () { update(); });
    }
  }

  /* 15. Hazard ticker: duplicate the list so the marquee loops seamlessly */
  function initTicker(root) {
    each('[data-rs-ticker]', root, function (t) {
      if (t.dataset.rsInit) return;
      t.dataset.rsInit = '1';
      if (reduce) return;
      var track = t.querySelector('.rs-ticker__track'), list = t.querySelector('.rs-ticker__list');
      if (!track || !list) return;
      var copy = list.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(copy.querySelectorAll('a'), function (a) { a.setAttribute('tabindex', '-1'); });
      track.appendChild(copy);
      t.classList.add('is-running');
    });
  }

  function initAll(root) {
    initReveal(root);
    initRotator(root);
    initCounters(root);
    initTerminal(root);
    initTilt(root);
    initMission(root);
    initRails(root);
    initTracker(root);
    initFacebook(root);
    initSpline(root);
    initBoot(root);
    initLive(root);
    initTicker(root);
  }

  initQuickAdd();
  initAnchors();
  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', function () { initAll(d); });
  } else {
    initAll(d);
  }
  /* Re-initialise when a section is edited in the theme editor */
  d.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();